import { useRef, useState } from 'react';
import { apiUploadImage } from '../api.js';

// 图片字段：链接输入 + 上传按钮(label 包裹 file) + 预览。匹配原应用样式。
export default function ImageUpload({ value, onChange }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = async (file) => {
    setError('');
    if (!file) return;
    if (!/^image\//.test(file.type)) {
      setError('请上传图片文件');
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('image', file);
      const data = await apiUploadImage(fd);
      onChange(data.imageUrl);
    } catch {
      setError('图片上传失败');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <div className="flex gap-4">
        <div className="flex-grow">
          <input
            type="text"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder="输入图片链接或点击右侧上传"
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="flex-shrink-0">
          <label className={`cursor-pointer bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg border border-gray-300 flex items-center gap-2 ${uploading ? 'opacity-60 pointer-events-none' : ''}`}>
            <input
              ref={fileRef}
              type="file"
              accept="image/*"
              className="hidden"
              onChange={(e) => handleFile(e.target.files?.[0])}
            />
            {uploading ? '上传中' : '上传图片'}
          </label>
        </div>
      </div>
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
      <div className="mt-2 w-40 h-40 bg-gray-100 rounded-lg overflow-hidden border relative flex items-center justify-center">
        {value ? (
          <img alt="预览" src={value} className="w-full h-full object-cover" />
        ) : (
          <span className="text-xs text-gray-400">暂无图片</span>
        )}
      </div>
    </div>
  );
}
